module.exports = __webpack_public_path__ + "static/media/about-bg.cda46faa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-bg.png
// module id = 412
// module chunks = 33